import React, { useState } from 'react';
import KnowledgeTextInput from './KnowledgeTextInput';
import KnowledgeFileUpload from './KnowledgeFileUpload';
import KnowledgeDocuments from './KnowledgeDocuments';
import { TagsConfigPage } from '../tags';

type Tab = 'add' | 'documents' | 'settings';

const KnowledgeLibraryPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<Tab>('add');

  return (
    <div
      className={`mx-auto py-8 px-4 sm:px-6 lg:px-8 w-full min-w-0 ${
        activeTab === 'settings' ? 'max-w-4xl' : 'max-w-[min(100%,1440px)]'
      }`}
    >
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-xl font-semibold text-gray-800">Knowledge Library</h1>
        <button
          onClick={() => setActiveTab((prev) => (prev === 'settings' ? 'add' : 'settings'))}
          className="px-3.5 py-2 text-sm font-medium rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 transition-colors"
        >
          {activeTab === 'settings' ? 'Back to Library' : 'Settings'}
        </button>
      </div>

      {/* Tab navigation */}
      {activeTab !== 'settings' && (
        <div className="flex border-b border-gray-200 mb-6">
          <button
            onClick={() => setActiveTab('add')}
            className={`px-4 py-2.5 text-sm font-medium transition-colors border-b-2 -mb-px ${
              activeTab === 'add'
                ? 'text-blue-600 border-blue-600'
                : 'text-gray-500 border-transparent hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            Add Knowledge
          </button>
          <button
            onClick={() => setActiveTab('documents')}
            className={`px-4 py-2.5 text-sm font-medium transition-colors border-b-2 -mb-px ${
              activeTab === 'documents'
                ? 'text-blue-600 border-blue-600'
                : 'text-gray-500 border-transparent hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            Document Library
          </button>
        </div>
      )}

      {/* Tab content */}
      {activeTab === 'add' && (
        <div className="space-y-8">
          <div className="bg-white border border-gray-200 rounded-xl p-6">
            <KnowledgeFileUpload />
          </div>
          <div className="bg-white border border-gray-200 rounded-xl p-6">
            <KnowledgeTextInput />
          </div>
        </div>
      )}

      {activeTab === 'documents' && (
        <div className="bg-white border border-gray-200 rounded-xl p-4 sm:p-5 lg:p-6 w-full min-w-0">
          <KnowledgeDocuments />
        </div>
      )}

      {activeTab === 'settings' && (
        <TagsConfigPage />
      )}
    </div>
  );
};

export default KnowledgeLibraryPage;
